export default __webpack_public_path__ + "static/media/IconDesc_Blender.64.24e04449.png";